const map = {};

function set(key, value) {
  map[key] = value;

  return map;
}

function get(key) {
  return map[key];
}

function clear(key) {
  map[key] = undefined;

  return map;
}

export { set, clear, get };
